import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

import { familyMessages } from '../variables/familyMessages';

interface UpdateFamilyParams {
	body: any;
	id: number;
}

export const updateFamily = async (body, id) => {
	const response = await api.patch(`/family?id=${id}`, {
		nome_familia: body.nome_familia,
	});
	return response.data;
};

export const useUpdateFamily = () => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(
		({ body, id }: UpdateFamilyParams) => updateFamily(body, id),
		{
			onSuccess: () => {
				queryClient.invalidateQueries(['family']);
				queryClient.invalidateQueries(['family-list']);
				queryClient.invalidateQueries(['family-list-with-products']);

				queryClient.refetchQueries(['family']);
				queryClient.refetchQueries(['family-list']);
				queryClient.refetchQueries(['family-list-with-products']);

				toast({
					title: familyMessages.MSG_FAMILY_UPDATED_SUCCESS,
					description: familyMessages.MSG_FAMILY_UPDATED_SUCCESS,
					position: 'bottom-left',
					status: 'success',
					duration: 8000,
					isClosable: true,
				});
			},
			onError: (error: any) => {
				const toastErrors: Array<any> = mapErrorToToastProps(
					error,
					familyMessages.MSG_FAMILY_UPDATE_ERROR
				);
				toastErrors?.forEach(element => toast(element));
			},
		}
	);
};
